<template>
  <div class="tabgroup-presentational mvt-searchfilter-body grid xs-grid-cols-1 gap-3">
    <header class="card-header">
      <button
          tracked="tracked"
          v-for="tab in tabs"
          :key="tab"
          :class="{ active: isActiveTab(tab) }"
          v-on:click="switchTab(tab);"
        >
          <div class="card-content">
            <slot :name="tabHeadSlotName(tab)">{{ tab }}</slot>
          </div>
      </button>
    </header>
    <main class="card-body">
      <div class="tab-panel"><slot :name="tabPanelSlotName"> </slot></div>
    </main>
  </div>
</template>

<script>
export default {
  name: 'TabGroupPresentational',
  inject: ['$eventBus'],
  props: {
    initialTab: String,
    tabs: Array,
    textAlign: {
      type: String,
      required: false,
      default: 'center',
    },
    eventCategory: String,
    eventAction: String,
  },
  data() {
    return {
      activeTab: this.initialTab
    };
  },
  computed: {
    tabPanelSlotName() {
      return `tab-panel-${this.activeTab}`;
    }
  },
  methods: {
    switchTab(tabName) {
      this.activeTab = tabName;
      if (this.$eventBus && this.eventAction && this.eventCategory) {
        this.$eventBus.$emit('ga', { ec: this.eventCategory, en: this.eventAction, el: this.activeTab });
      }
    },
    isActiveTab(tab) {
      return this.activeTab === tab;
    },
    tabHeadSlotName(tab) {
      return `tab-head-${tab}`;
    }
  }
};
</script>

<style lang="scss">
@use "~@/common/scss/base/_defined.scss" as *;

.card-header {
  background: var(--color-f2);
  padding: 0.25rem;
  border-radius: 2rem;
  display: flex;
  justify-content: space-between;
  @media (max-width: $screen-xs-max) {
    @include f6();
  }
  button {
    border-radius: 2rem;
    border-radius: 2rem;
    width: 100%;
    text-align: center;
    line-height: 75%;
    padding: 0.75rem 1.5rem;
    cursor: pointer;
    @media (max-width: $screen-xs-max) {
      padding: 0.75rem 0.5rem;
    }
    &.active {
      background: var(--color-bg);
    }
  }
}
.tab-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0px;
  cursor: pointer;
  border-bottom: 1px solid black;
  &.active{
    border-bottom: 2px solid black;
  }
}
</style>